import { render, staticRenderFns } from "./isPro1.vue?vue&type=template&id=64795a21&scoped=true&"
import script from "./isPro1.vue?vue&type=script&lang=js&"
export * from "./isPro1.vue?vue&type=script&lang=js&"
import style0 from "./isPro1.vue?vue&type=style&index=0&id=64795a21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64795a21",
  null
  
)

export default component.exports